import {
  Activity,
  Brain,
  CandlestickChart,
  Gauge,
  Layers,
  Newspaper,
  Radar,
  ShieldCheck,
  Waves,
  Zap,
} from "lucide-react";

export const engines = [
  {
    name: "Liquidity Engine",
    tag: "Liquidity Detection",
    icon: Waves,
    detail: "Maps sweeps, equal highs/lows and resting orders.",
  },
  {
    name: "Smart Money Engine",
    tag: "SMC / ICT Structure",
    icon: Brain,
    detail: "Break of structure, order blocks, FVG confluence.",
  },
  {
    name: "Order Flow Engine",
    tag: "Delta & Absorption",
    icon: Layers,
    detail: "Aggressive flow imbalance and absorption reads.",
  },
  {
    name: "Risk Engine",
    tag: "Final Decision Maker",
    icon: ShieldCheck,
    detail: "Vetoes every setup that breaks exposure rules.",
    primary: true,
  },
  {
    name: "News Impact Engine",
    tag: "Macro Event Filter",
    icon: Newspaper,
    detail: "Blocks entries inside high-impact release windows.",
  },
  {
    name: "Sentiment Engine",
    tag: "Positioning Bias",
    icon: Radar,
    detail: "Retail vs institutional positioning divergence.",
  },
  {
    name: "Volatility Engine",
    tag: "Regime Detection",
    icon: Activity,
    detail: "ATR regime shifts and expansion windows.",
  },
  {
    name: "Trend Engine",
    tag: "Multi-Timeframe Bias",
    icon: CandlestickChart,
    detail: "HTF directional alignment scoring.",
  },
  {
    name: "Execution Engine",
    tag: "Order Routing",
    icon: Zap,
    detail: "Latency-aware fills, partials and trail logic.",
  },
];

export const news = [
  {
    time: "Today · 18:30",
    title: "US CPI (YoY)",
    impact: "high",
    phase: "Upcoming",
    insight: "Expected bearish USD if print < 2.8% — gold expansion likely.",
  },
  {
    time: "Today · 23:00",
    title: "FOMC Rate Decision",
    impact: "high",
    phase: "Upcoming",
    insight: "Volatility trap window. Execution paused ±30 min.",
  },
  {
    time: "Yesterday · 19:00",
    title: "US Jobless Claims",
    impact: "medium",
    phase: "Past",
    insight: "Bullish reaction confirmed, XAU swept liquidity then reversed.",
  },
  {
    time: "Mon · 14:00",
    title: "ECB Press Conference",
    impact: "medium",
    phase: "Past",
    insight: "Range compression, engines stayed flat by design.",
  },
];

export const trades = [
  {
    pair: "XAU/USD",
    side: "LONG",
    entry: "2,398.40",
    sl: "2,391.10",
    t1: "2,409.80",
    t2: "2,421.50",
    status: "Executed",
    confidence: 87,
    progress: 62,
    reason:
      "Asian low liquidity sweep + 15m BOS, bullish FVG retest with positive delta absorption at the origin block.",
  },
  {
    pair: "BTC/USDT",
    side: "SHORT",
    entry: "64,820",
    sl: "65,410",
    t1: "63,900",
    t2: "62,750",
    status: "Pending",
    confidence: 74,
    progress: 18,
    reason:
      "HTF supply reclaim failure, funding skew stretched, awaiting 4h close confirmation before routing.",
  },
  {
    pair: "EUR/USD",
    side: "LONG",
    entry: "1.0842",
    sl: "1.0818",
    t1: "1.0871",
    t2: "1.0904",
    status: "Closed",
    confidence: 91,
    progress: 100,
    reason:
      "London open sweep into daily demand, T2 achieved before CPI window closed execution.",
  },
];

export const alerts = [
  { kind: "Trade Executed", text: "XAU/USD long filled @ 2,398.40", tone: "bull", ago: "12s" },
  { kind: "Target Achieved", text: "EUR/USD T2 hit · +2.4R", tone: "bull", ago: "4m" },
  { kind: "SL Hit", text: "GBP/JPY short stopped · -1.0R", tone: "bear", ago: "21m" },
  { kind: "Engine Alert", text: "News Engine paused execution (CPI)", tone: "warn", ago: "38m" },
  { kind: "Trade Executed", text: "BTC/USDT short queued @ 64,820", tone: "bull", ago: "51m" },
];

export const equityCurve = [
  { d: "W1", pnl: 2.1 },
  { d: "W2", pnl: 4.6 },
  { d: "W3", pnl: 3.8 },
  { d: "W4", pnl: 7.2 },
  { d: "W5", pnl: 9.9 },
  { d: "W6", pnl: 9.1 },
  { d: "W7", pnl: 13.4 },
  { d: "W8", pnl: 17.8 },
];

export const gaugeIcon = Gauge;
